const cookiesNotification = () => {
	if (document.querySelector('[data-js="cookies-notice"]')) {
		const setCookie = (name, val, days, path, domain, secure) => {
			if (navigator.cookieEnabled) {
				const cookieName = encodeURIComponent(name);
				const cookieVal = encodeURIComponent(val);
				let cookieText = `${cookieName}=${cookieVal}`;

				if (typeof days === 'number') {
					const data = new Date();
					data.setTime(data.getTime() + days * 24 * 60 * 60 * 1000);
					cookieText += `; expires=${data.toGMTString()}`;
				}

				if (path) {
					cookieText += `; path=${path}`;
				}
				if (domain) {
					cookieText += `; domain=${domain}`;
				}
				if (secure) {
					cookieText += `; secure`;
				}

				document.cookie = cookieText;
			}
		};

		const showCookie = (name) => {
			if (document.cookie !== '') {
				const cookies = document.cookie.split(/; */);

				for (let i = 0; i < cookies.length; i += 1) {
					const cookiePart = cookies[i].split('=');
					const cookieName = cookiePart[0];
					const cookieVal = cookiePart[1];
					if (cookieName === decodeURIComponent(name)) {
						return decodeURIComponent(cookieVal);
					}
				}
			}
			return false;
		};

		const cookieNotice = document.querySelector('[data-js="cookies-notice"]');
		const cookieNoticeClose = document.querySelector('[data-js="cookies-notice-close"]');

		if (!showCookie('BYBMCOOKIES')) {
			setCookie('BYBMCOOKIES', 'unaccepted', 365, '/');
		}
		if (showCookie('BYBMCOOKIES') === 'unaccepted') {
			cookieNotice.classList.add('is-visible');
		}

		cookieNoticeClose.addEventListener('click', (event) => {
			event.preventDefault();
			setCookie('BYBMCOOKIES', 'accepted', 365, '/');
			cookieNotice.classList.remove('is-visible');
		});
	}
};

export default cookiesNotification;
